"use strict";
// useIntersectionObserver is used to check if the element is visible in the viewport or not.
// useIntersectionObserver return intersectionObserverEntry
// interface IntersectionObserverEntry { isIntersecting: boolean; target: Element; ... }
// intersectionObserverEntry.isIntersecting indicates whether the target element is intersecting with the root element at the time when intersection is checked (by default, the viewport).
// catchOnlyFirstAppearance is used to catch only the first appearance of the element in the viewport.
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntersectionObserver = void 0;
var react_1 = require("react");
function useIntersectionObserver(elementRef, options, catchOnlyFirstAppearance) {
    var _a = __read((0, react_1.useState)(), 2), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    var frozen = (intersectionObserverEntry === null || intersectionObserverEntry === void 0 ? void 0 : intersectionObserverEntry.isIntersecting) && catchOnlyFirstAppearance;
    (0, react_1.useEffect)(function () {
        var node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current; // DOM Ref
        var hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node)
            return;
        var observer = new IntersectionObserver(function (_a) {
            var _b = __read(_a, 1), entry = _b[0];
            setIntersectionObserverEntry(entry);
        }, options);
        observer.observe(node);
        return function () { return observer.disconnect(); };
    }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, options === null || options === void 0 ? void 0 : options.rootMargin, frozen]);
    return intersectionObserverEntry;
}
exports.useIntersectionObserver = useIntersectionObserver;
